import DependientesComponent from "../components/Dependientes/Dependientes";
export default function Dependientes() {
  return <DependientesComponent />;
}
